import React from 'react'
import { useSiteSettings } from '../hooks/useSiteSettings'

interface SiteSettingsProviderProps {
  children: React.ReactNode
}

const SiteSettingsProvider: React.FC<SiteSettingsProviderProps> = ({ children }) => {
  useSiteSettings() // This will apply the settings globally

  return <>{children}</>
}

export default SiteSettingsProvider
